import React from 'react';

import {MOON_250} from '../../../../common/css/color.styles';

export const NotApplicable = () => {
  return <div style={{color: MOON_250}}>N/A</div>;
};
